import { RootState } from "@/store/dtm";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { legalTermsType } from "@/types/legalTermsType"



export interface legalTermsState {
    legalTerms: legalTermsType
}

const initialState: legalTermsState = {
    legalTerms: {
        resStatus: false,
        taxResidentorCitizenUs: false,
        taxNotCanadaNotUS: false,
        polExposed: false,
        ontarioWork: false,
        ownerOperator: false,
        meridianOnly: false,
        occupation: "",
        natureOfBanking: "",
        primaryPurpose: "",
        primaryOtherPurpose: "",
        primaryPurposeGIC: "",
        primaryOtherPurposeGIC: "",
        crsUsTin: "",
        crsTin: "",
        crsCountry: "",
        politicallyExposedType: "",
        positionHeld: "",
        countryPositionHeld: "",
        fieldsCompleted: false
    }
}

export const legalTermsSlice = createSlice({
    name: "legalTerms",
    initialState,
    reducers: {
        setResStatus: (state, action: PayloadAction<boolean>) => {
            const resStatus = action.payload;
            state.legalTerms.resStatus = resStatus;
        },
        setTaxResidentorCitizenUs: (state, action: PayloadAction<boolean>) => {
            const taxResidentorCitizenUs = action.payload;
            state.legalTerms.taxResidentorCitizenUs = taxResidentorCitizenUs;
        },
        setTaxNotCanadaNotUS: (state, action: PayloadAction<boolean>) => {
            const taxNotCanadaNotUS = action.payload;
            state.legalTerms.taxNotCanadaNotUS = taxNotCanadaNotUS;
        },
        setPolExposed: (state, action: PayloadAction<boolean>) => {
            const polExposed = action.payload;
            state.legalTerms.polExposed = polExposed;
        },
        setOntarioWork: (state, action: PayloadAction<boolean>) => {
            const ontarioWork = action.payload;
            state.legalTerms.ontarioWork = ontarioWork;
        },
        setOwnerOperator: (state, action: PayloadAction<boolean>) => {
            const ownerOperator = action.payload;
            state.legalTerms.ownerOperator = ownerOperator;
        },
        setMeridianOnly: (state, action: PayloadAction<boolean>) => {
            const meridianOnly = action.payload;
            state.legalTerms.meridianOnly = meridianOnly;
        },
        setOccupation: (state, action: PayloadAction<string>) => {
            const occupation = action.payload;
            state.legalTerms.occupation = occupation;
        },
        setNatureOfBanking: (state, action: PayloadAction<string>) => {
            const natureOfBanking = action.payload;
            state.legalTerms.natureOfBanking = natureOfBanking;
        },
        setPrimaryPurpose: (state, action: PayloadAction<string>) => {
            const primaryPurpose = action.payload;
            state.legalTerms.primaryPurpose = primaryPurpose;
        },
        setPrimaryPurposeGIC: (state, action: PayloadAction<string>) => {
            const primaryPurposeGIC = action.payload;
            state.legalTerms.primaryPurposeGIC = primaryPurposeGIC;
        },
        setPrimaryOtherPurpose: (state, action: PayloadAction<string>) => {
            const primaryOtherPurpose = action.payload;
            state.legalTerms.primaryOtherPurpose = primaryOtherPurpose;
        },
        setPrimaryOtherPurposeGIC: (state, action: PayloadAction<string>) => {
            const primaryOtherPurposeGIC = action.payload;
            state.legalTerms.primaryOtherPurposeGIC = primaryOtherPurposeGIC;
        },
        setCrsUsTin: (state, action: PayloadAction<string>) => {
            const crsUsTin = action.payload;
            state.legalTerms.crsUsTin = crsUsTin;
        },
        setCrsTin: (state, action: PayloadAction<string>) => {
            const crsTin = action.payload;
            state.legalTerms.crsTin = crsTin;
        },
        setCrsCountry: (state, action: PayloadAction<string>) => {
            const crsCountry = action.payload;
            state.legalTerms.crsCountry = crsCountry;
        },
        setPoliticallyExposedType: (state, action: PayloadAction<string>) => {
            const politicallyExposedType = action.payload;
            state.legalTerms.politicallyExposedType = politicallyExposedType;
        },
        setPositionHeld: (state, action: PayloadAction<string>) => {
            const positionHeld = action.payload;
            state.legalTerms.positionHeld = positionHeld;
        },
        setCountryPositionHeld: (state, action: PayloadAction<string>) => {
            const countryPositionHeld = action.payload;
            state.legalTerms.countryPositionHeld = countryPositionHeld;
        },
        setAMLFieldsCompleted: (state, action: PayloadAction<boolean>) => {
            const fieldsCompleted = action.payload;
            state.legalTerms.fieldsCompleted = fieldsCompleted;
        },
        clearLegalTermsState: (state) => {
            state.legalTerms.resStatus = false,
                state.legalTerms.taxResidentorCitizenUs = false,
                state.legalTerms.taxNotCanadaNotUS = false,
                state.legalTerms.polExposed = false,
                state.legalTerms.ontarioWork = false,
                state.legalTerms.meridianOnly = false,
                state.legalTerms.occupation = "",
                state.legalTerms.natureOfBanking = "",
                state.legalTerms.primaryPurpose = "",
                state.legalTerms.primaryOtherPurpose = "",
                state.legalTerms.primaryPurposeGIC = "",
                state.legalTerms.primaryOtherPurposeGIC = "",
                state.legalTerms.crsUsTin = "",
                state.legalTerms.crsTin = "",
                state.legalTerms.crsCountry = "",
                state.legalTerms.politicallyExposedType = "",
                state.legalTerms.positionHeld = "",
                state.legalTerms.countryPositionHeld = "",
                state.legalTerms.ownerOperator = false,
                state.legalTerms.fieldsCompleted = false
        },
        clearTaxResidentorCitizenUsState: (state) => {
            state.legalTerms.crsUsTin = ""
        },
        clearTaxNotCanadaNotUsState: (state) => {
            state.legalTerms.crsTin = "",
                state.legalTerms.crsCountry = ""
        },
        clearPolExposedState: (state) => {
            state.legalTerms.politicallyExposedType = "",
                state.legalTerms.positionHeld = "",
                state.legalTerms.countryPositionHeld = ""
        }
    }
});

export const { setResStatus, setCountryPositionHeld, setCrsCountry, setCrsTin, setCrsUsTin, setMeridianOnly, setNatureOfBanking, setOccupation, setOntarioWork,
    setOwnerOperator, setPolExposed, setPoliticallyExposedType, setPrimaryPurpose, setPrimaryOtherPurpose, setTaxNotCanadaNotUS, setTaxResidentorCitizenUs,
    setPositionHeld, clearLegalTermsState, clearPolExposedState, clearTaxNotCanadaNotUsState, clearTaxResidentorCitizenUsState, setAMLFieldsCompleted,
    setPrimaryPurposeGIC, setPrimaryOtherPurposeGIC } = legalTermsSlice.actions

export default legalTermsSlice.reducer

export const selectLegalTerms = (state: RootState) => state.legalTerms;
